export enum ANIMATION_TYPES {
  CHILD_VIEW_LEFT_SLIDE = 'child_view_left_slide',
  CHILD_VIEW_RIGHT_SLIDE = 'child_view_right_slide',
  OVERLAY_VIEW = 'overlay_view',
}
